var map = {
	"./application.svg": "654d",
	"./attendance.svg": "3a0b",
	"./camera.svg": "630f",
	"./classroom.svg": "273d",
	"./d2-admin-text.svg": "ae5c",
	"./d2-admin.svg": "bb12",
	"./dataReport.svg": "7e05",
	"./face.svg": "2a16",
	"./feature.svg": "baad",
	"./kaoqintongji.svg": "47f3",
	"./learning.svg": "5075",
	"./return2.svg": "b096",
	"./role.svg": "046d",
	"./school.svg": "a398",
	"./setting.svg": "749a",
	"./users.svg": "1728",
	"./xitongshezhi.svg": "ca1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec39";